<div class="qr-code-dialog">
    <h2 mat-dialog-title>{{ 'Ecommerce.POS.see_qr_code' | transloco }}</h2>

    <div mat-dialog-content class="qr-code-content">
        <div class="table-name">
            <h3>{{ tableName }}</h3>
        </div>

        <div class="qr-code-container" *ngIf="qrCodeValue">
            <qrcode
                [qrdata]="qrCodeValue"
                [width]="256"
                [errorCorrectionLevel]="'M'"
                [elementType]="'canvas'"
            ></qrcode>
        </div>

        <div class="no-token-message" *ngIf="!qrCodeValue">
            <p>{{ 'Ecommerce.POS.no_token_available' | transloco }}</p>
        </div>

        <div class="token-value" *ngIf="qrCodeValue">
            <p class="token-label">Token:</p>
            <p class="token-text">{{ qrCodeValue }}</p>
        </div>
    </div>

    <div mat-dialog-actions align="center">
        <button mat-raised-button color="primary" (click)="onClose()">
            {{ 'cancel' | transloco }}
        </button>
    </div>
</div>
